import KiriFont from "./kirifont-webfont.woff"
import KiriFont2 from "./kirifont-webfont.woff2"
//import KiriFont from "./KiriFont.ttf"

export { KiriFont, KiriFont2 }